import React from "react";
import { func, bool, string } from "prop-types";
import styled from "styled-components";

import MapButton from "../shared/MapButton";
import FilterIcon from "../shared/Icons/Filter";
import CloseIcon from "../shared/Icons/Close";

import gtm from "@gtm/core";
import { displayMapFilterEvent } from "@gtm/events/testdrive";
import { useTranslation } from "@lib/i18n";

const StyledCloseIcon = styled(CloseIcon)`
  transform: scale(0.75);
`;

const MapFilterButton = ({ accentColor, setIsFilterOpen, isFilterOpen }) => {
  const { t } = useTranslation();

  const toggleFilter = () => {
    setIsFilterOpen(!isFilterOpen);
    if (!isFilterOpen) {
      gtm.fire(displayMapFilterEvent());
    }
  };

  return (
    <MapButton
      color={accentColor}
      aria-label={isFilterOpen ? t("basket.back") : "Filter"}
      onClick={toggleFilter}
    >
      {isFilterOpen ? (
        <StyledCloseIcon
          data-id="test-drive-map-filter-close-icon"
          color={accentColor}
        />
      ) : (
        <FilterIcon data-id="test-drive-map-filter-icon" color={accentColor} />
      )}
    </MapButton>
  );
};

MapFilterButton.propTypes = {
  setIsFilterOpen: func.isRequired,
  isFilterOpen: bool.isRequired,
  accentColor: string.isRequired,
};

export default MapFilterButton;
